<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Purchase Membership</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="membershipSelect">Membership Type</label>
      <select id="membershipSelect" class="custom-select" name="membership"
              [(ngModel)]="membershipId" required
              (ngModelChange)="onMembershipChange()"
              [disabled]="loadingMemberships" [class.disabled]="loadingMemberships">
        <option *ngIf="loadingMemberships">Loading...</option>
        <option *ngIf="!loadingMemberships" [value]="null">---</option>
        <option *ngFor="let membershipType of membershipList" [value]="membershipType.id">
          {{ membershipType.name }}
          <ng-container *ngIf="membershipType.status === MembershipStatus.retired">(Retired)</ng-container>
          <ng-container *ngIf="membershipType.status === MembershipStatus.draft">(Draft)</ng-container>
        </option>
      </select>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <p class="mb-0 mt-4">
      The button below will take you to the Climber App purchase page for the selected Membership, logged in as {{ customer.first_name }} {{ customer.last_name }}. From there you can complete the purchase.
    </p>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!(loadingMemberships || loadingSubmit)"
            [disabled]="membershipId === null || isAgeBlocked()"
            [class.disabled]="membershipId === null || isAgeBlocked()"
            (click)="handleSave()">
      Go to Climber App
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingMemberships || loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
